import { useState, useCallback } from 'react';
import EntrepriseService from '../services/entrepriseService';
import RoleHelper from '../utils/roleHelper';

export const useCredits = (currentUser, adminImpersonatingRecruteurId, history) => {
    const [creditsInfo, setCreditsInfo] = useState({ available: null, maximum: null });
    const [isLoadingCredits, setIsLoadingCredits] = useState(false);
    const entrepriseService = new EntrepriseService();

    const fetchCredits = useCallback(async () => {
        if (RoleHelper.isEntreprise(currentUser) || (adminImpersonatingRecruteurId && RoleHelper.isAdminImpersonatingEntreprise(currentUser, history.location.pathname))) {
            setIsLoadingCredits(true);
            try {
                const credits = await entrepriseService.getCreditsInfo(adminImpersonatingRecruteurId);
                setCreditsInfo(credits);
                return credits;
            } catch (error) {
                console.error('Erreur lors de la récupération des crédits:', error);
                return null;
            } finally {
                setIsLoadingCredits(false);
            }
        }
        return null;
    }, [currentUser, adminImpersonatingRecruteurId, history.location.pathname]);

    const executeActionWithCreditCheck = useCallback(async (actionFunction) => {
        try {
            const result = await actionFunction();
            
            // Si l'action a consommé un crédit, recharger les crédits
            if (result && result.creditConsumed) {
                // Si les nouveaux crédits sont fournis dans la réponse, les utiliser
                if (result.newCreditsInfo) {
                    setCreditsInfo(result.newCreditsInfo);
                } else {
                    // Sinon, refetch depuis le serveur
                    await fetchCredits();
                }
            }
            
            return result;
        } catch (error) {
            console.error('Erreur lors de l\'exécution de l\'action:', error);
            return { success: false, creditConsumed: false, message: 'Erreur inattendue' };
        }
    }, [fetchCredits]);

    return {
        creditsInfo,
        isLoadingCredits,
        fetchCredits,
        executeActionWithCreditCheck,
        refreshCredits: fetchCredits
    };
};
